'use client';

import BairesDevFooter from 'layout/src/components/footer';
import React from 'react';
import { ThemeEnum } from 'ui/src/components/Theme';
import addUrlHostName from 'ui/src/utils/addUrlHostname';
import ButtonArrowIcon from 'ui/src/icons/ButtonArrowIcon';
import EmailIcon from 'ui/src/icons/EmailIcon';
import FooterBGEnum from 'layout/src/components/footer/FooterBGEnum';
import { MenuFragmentFragment, MenuLocationEnum } from 'gql/graphql-operations';
import { getMenuTree } from 'utils/shared';
import type { FooterMenu } from 'layout/src/data/FooterMenuType';
import { usePathname } from 'next/navigation';

type Props = {
  year: number;
  // TODO: Define explicit types to eliminate reliance on generated types, which currently introduce unwanted dependencies in the component.
  menuItems: Partial<Record<MenuLocationEnum, MenuFragmentFragment | null>>;
  csrfToken?: string;
};

const darkFooterRoutes = new Set(['']);

export default function Footer({ year, menuItems, csrfToken }: Props) {
  let footerMenus: FooterMenu[] = [];

  const pathname = usePathname() || '';

  const bgFooter =
    darkFooterRoutes.has(pathname) || pathname.match(/^(?!\/search\/$)\/[^/]+\/$/)
      ? FooterBGEnum.Dark
      : FooterBGEnum.Light;

  footerMenus = [
    {
      title: menuItems[MenuLocationEnum.Footer_1]?.name ?? '',
      menuItems: getMenuTree(menuItems, MenuLocationEnum.Footer_1),
    },
    {
      title: menuItems[MenuLocationEnum.Footer_2]?.name ?? '',
      menuItems: getMenuTree(menuItems, MenuLocationEnum.Footer_2),
    },
    {
      title: menuItems[MenuLocationEnum.Footer_3]?.name ?? '',
      menuItems: getMenuTree(menuItems, MenuLocationEnum.Footer_3),
    },
  ];

  return (
    <BairesDevFooter<ThemeEnum.Site>
      year={year}
      contactusUrl={addUrlHostName('/contact-us/')}
      placeholder="name@email.com"
      label="Your e-mail address"
      hasSocialTitle
      bgFooter={bgFooter}
      logoPath={`${process.env.NEXT_PUBLIC_BASE_PATH ?? ''}/bairesdev-logo-footer.svg`}
      logoSize={[60, 40]}
      menus={footerMenus}
      subscriptionApi={`${process.env.NEXT_PUBLIC_BASE_PATH}/api/subscribe/`}
      buttonsProps={{
        scheduleCallBtn: {
          variant: 'Primary',
          icon: ButtonArrowIcon,
        },
        contactUsBtn: {
          variant: 'Secondary',
          variantColor: 'Black',
        },
        subscriptionBtn: {
          variant: 'Secondary',
          variantColor: 'Black',
          icon: EmailIcon,
          iconPosition: 'right',
        },
      }}
      withFullStops
      csrfToken={csrfToken}
    />
  );
}
